export const userNameError = 'Please enter a name!';
export const userEmailError = 'Please enter a valid email!';
export const userEmailValidError = 'Please enter an email!';
export const userPasswordError = 'Please enter a temporary password!';
export const errorUserCreation = 'Failed to create user';
export const nameLabel = 'NAME';
export const namePlaceholder = 'Name...';
export const emailLabel = 'EMAIL';
export const emailPlaceholder = 'Email...';
export const phoneNumberLabel = 'PHONE NUMBER';
export const phoneNumberPlaceholder = 'Phone number...';
export const passwordLabel = 'TEMPORARY PASSWORD';
export const passwordPlaceholder = 'Temporary password...';
export const addRegionPlaceholder = 'Add a region...';
export const selectedRegionTitle = 'SELECTED REGIONS';
export const closeIconAlt = 'Close button';
export const noRegionsWarning = 'There are no selected regions yet...';
export const disabledButtonWarning = 'Please fill out all info to create this user.';
export const createButtonText = 'create';
export const successUserMessage = (message) => `Successfully created ${message}!`;
export const titleWithRole = (role) => `Create new ${role}`;
